import { Box, Divider, FormControlLabel, MenuItem, Select, Stack, Switch, TextField, Typography } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { useTranslation } from 'react-i18next';
import { NOTIF_CATEGORIES } from '../../../Constants/userConstants';

const FIELD_HEIGHT = 36;
const fieldSx = { '& .MuiInputBase-root': { height: FIELD_HEIGHT, fontSize: 13 } };

// eslint-disable-next-line react/prop-types
const InfoStep = ({
  name, onNameChange,
  email, onEmailChange,
  jobTitle, onJobTitleChange,
  phone, onPhoneChange,
  profileKey, onProfileChange,
  profileOptions,
  inviteType,
  notifPrefs, onNotifPrefChange,
}) => {
  const { t } = useTranslation('users');
  const selectedProfileCode = profileOptions.find((o) => o.value === profileKey)?.code ?? '';
  const notifCategories = NOTIF_CATEGORIES[selectedProfileCode] ?? [];

  return (
    <Stack spacing={2}>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <TextField
          label={t('invite.fields.name')}
          name="name"
          id="invite-field-name"
          autoComplete="name"
          size="small"
          required
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={t('invite.placeholders.name')}
          sx={fieldSx}
        />
        <TextField
          label={t('invite.fields.email')}
          name="email"
          id="invite-field-email"
          autoComplete="email"
          size="small"
          required
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          placeholder={t('invite.placeholders.email')}
          sx={fieldSx}
        />
        <TextField label={t('invite.fields.jobTitle')} size="small" value={jobTitle} onChange={(e) => onJobTitleChange(e.target.value)} placeholder={t('invite.placeholders.jobTitle')} sx={fieldSx} />
        <MuiTelInput label={t('invite.fields.phone')} size="small" defaultCountry="PT" value={phone} onChange={onPhoneChange} sx={fieldSx} />
        <Box sx={{ gridColumn: '1 / span 2' }}>
          <Select
            size="small" displayEmpty fullWidth
            value={profileKey}
            disabled={inviteType === 'entra' && profileOptions.length <= 1}
            onChange={(e) => onProfileChange(e.target.value)}
            sx={{ height: FIELD_HEIGHT, fontSize: 13 }}
          >
            <MenuItem value="" disabled sx={{ fontSize: 13 }}>{t('invite.fields.profile')}</MenuItem>
            {profileOptions.map((o) => (
              <MenuItem key={o.value} value={o.value} sx={{ fontSize: 13 }}>{o.label}</MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      {notifCategories.length > 0 && (
        <Box>
          <Divider sx={{ mb: 2 }} />
          <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.06em', mb: 1 }}>
            {t('notificationPreferences.title')}
          </Typography>
          <Stack spacing={0.5}>
            {notifCategories.map((cat) => (
              <FormControlLabel
                key={cat}
                control={(
                  <Switch
                    size="small"
                    checked={!!notifPrefs[cat]}
                    onChange={(e) => onNotifPrefChange(cat, e.target.checked)}
                  />
                )}
                label={(
                  <Box>
                    <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
                      {t(`notificationPreferences.categories.${cat}`)}
                    </Typography>
                    <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>
                      {t(`notificationPreferences.descriptions.${cat}`)}
                    </Typography>
                  </Box>
                )}
              />
            ))}
          </Stack>
        </Box>
      )}
    </Stack>
  );
};

export default InfoStep;
